export default "__VITE_ASSET__CoWFip92__"